import useCreateTaskDias from '../mutations/useCreateTaskDias';
import useExportPartyToDias from '../mutations/useExportPartyToDias';
import useUploadDocumentsDias from '../mutations/useUploadDocumentsDias';

export default function useActionsDias() {
  const { mutateAsync: createTask } = useCreateTaskDias();
  const { mutateAsync: exportParty } = useExportPartyToDias();
  const { mutateAsync: uploadDocuments } = useUploadDocumentsDias();

  return {
    createTask,
    exportParty,
    uploadDocuments,
  };
}
